import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { theme, ThemeProvider } from "@sgi/gravity";
import "./index.css";
import BaseRemover from "./Components/BaseRemover";

declare global {
  interface Window {
    SETTINGS: any;
    CONTENT: any;
  }
}

export default function main() {
  console.log("Settings: ", window.SETTINGS);
  console.log("Content: ", window.CONTENT);

  let triggered = false;
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") continue;
      mutation.addedNodes.forEach((node) => {
        const htmlElement = node as HTMLElement;
        if (htmlElement.id !== "root") return;
        onReady(htmlElement, true);
      });
    }
  });
  observer.observe(document.body, {childList: true});

  const rootElement = document.getElementById("root");
  if (rootElement !== null) onReady(rootElement, false);

  function onReady(rootHtmlElement: HTMLElement, fromMutation: boolean) {
    if (triggered) return;
    triggered = true;

    observer.disconnect();

    console.log("Ready. fromMutation=", fromMutation);

    const root = ReactDOM.createRoot(rootHtmlElement);
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <App/>
        </ThemeProvider>
        <BaseRemover />
      </React.StrictMode>
    );
  }
}

main();